exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-in-row {  \r\n  margin-top: 15px; \r\n}\r\n\r\n.header-seccion-form {\r\n\tbackground-color: #d2d0d0;\t\r\n}\r\n\r\n.content-help-desktop {\r\n\tbackground-color: #30B0D0;\r\n\tcolor: white;\r\n\tmin-height: 0px;\r\n\tpadding: 10px;\r\n\tborder-radius: 5px;\r\n}\r\n\r\n.content-help-desktop:empty {\r\n\tdisplay: none;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/350/v5/ng_retefuente350v5/Front_formReteFuente350v5/src/app/components/formulario/formulario/formulario.component.css
// module id = ../../../../../src/app/components/formulario/formulario/formulario.component.css
// module chunks = main